import { getFeatureFlag } from '../services/getFeatureFlag';

// eslint-disable-next-line
export const AUTH_SERVICE = process.env.REACT_APP_AUTH_SERVICE;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA || '';
export const REZDY_APP_LOGIN = process.env.REACT_APP_REZDY_APP_LOGIN;
export const REZDY_APP = process.env.REACT_APP_REZDY_APP;
export const RECAPTCHA_ENABLED = (process.env.REACT_APP_RECAPTCHA_ENABLED as string) || '';
export const REZDY_DOMAIN = process.env.REACT_APP_REZDY_DOMAIN || '';
export const CHANGE_EMAIL_FLOW_V2 = process.env.REACT_APP_CHANGE_EMAIL_FLOW_V2 == 'true';
export const LOGIN_V2 = getFeatureFlag('LOGIN_V2') == 'true';
export const CONTACT_SUPPORT = 'https://rezdy.com/contact-rezdy/';

export default {
    AUTH_SERVICE,
    RECAPTCHA_ENABLED,
    REZDY_APP_LOGIN,
    REZDY_DOMAIN,
};
